/**
 * BookMyInterview.ai brand logo — shared, use everywhere.
 *
 * Variants:
 *   - "mark"     — icon only (coral bubble + white check + teal dot). Square.
 *   - "wordmark" — mark + "bookmyinterview.ai" text.
 *   - "auth"     — wordmark stacked over "HIRE. FASTER." tagline.
 *
 * Colors are fixed brand hex (do NOT theme these — they identify the brand).
 * Buttons/CTAs continue to use the terracotta `--primary` CSS var.
 */
import React from "react";

const CORAL = "#c76b52";
const TEAL = "#2f8a92";
const INK = "#1c1917";

export function BrandMark({ size = 32, className = "", title = "BookMyInterview.ai" }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            role="img"
            aria-label={title}
        >
            <path
                fill={CORAL}
                d="M14 6h32a8 8 0 0 1 8 8v22a8 8 0 0 1-8 8H26.5l-9.3 8.5A1.4 1.4 0 0 1 15 51.4V44h-1a8 8 0 0 1-8-8V14a8 8 0 0 1 8-8z"
            />
            <path
                fill="#ffffff"
                stroke="#ffffff"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 25.6l7.6 7.6L44 15"
            />
            <circle cx="48" cy="12" r="4.6" fill={TEAL} />
        </svg>
    );
}

/**
 * Wordmark: [icon] bookmyinterview.ai (with .ai coral accent).
 * Renders inline; text scales with the given wordSize.
 */
export default function BrandLogo({
    size = 26,
    wordSize = "text-lg",
    tagline = false,
    className = "",
    testid,
}) {
    return (
        <span
            className={`inline-flex items-center gap-2 ${className}`}
            data-testid={testid}
        >
            <BrandMark size={size} />
            <span className="flex flex-col leading-none">
                <span
                    className={`font-sans font-extrabold tracking-tight ${wordSize}`}
                    style={{ color: INK, letterSpacing: "-0.02em" }}
                >
                    bookmyinterview<span style={{ color: CORAL }}>.ai</span>
                </span>
                {tagline && (
                    <span
                        className="text-[9px] uppercase mt-1 font-semibold"
                        style={{ color: TEAL, letterSpacing: "0.32em" }}
                    >
                        Hire. Faster.
                    </span>
                )}
            </span>
        </span>
    );
}

export const BRAND_CORAL = CORAL;
export const BRAND_TEAL = TEAL;
export const BRAND_INK = INK;
